import React, { useEffect, useState } from 'react';
import { Radar } from 'react-chartjs-2';
import Loader from '../../Utilities/Loader/Loader';

import './RadarChart.css';

const label = [
  'ANIMATION',
  'DOCUMENTAIRE',
  'JEUNESSE',
  'MAGAZINE',
  'REPORTAGE',
  'SPORT',
  'VARIÉTÉ',
  'TOUTES CATÉGORIES', 
  'TALK-SHOW',
  'HUMOUR',
  'FICTION-MASCULIN',
  'FICTION-FEMININ',
  'FICTION',
  'AFFAIRES PUBLIQUES',
];

function RadarChart(props) {

  const [radarChartData, setRadarChartData] = useState();

  useEffect(() => {
    setRadarChartData(props.radarChartData);
  }, [props]);

  const [themesSelected, setThemesSelected] = useState({
    'AFFAIRES PUBLIQUES' : true,
    'ANIMATION' : true,
    'DOCUMENTAIRE' : true,
    'JEUNESSE' : true,
    'MAGAZINE' : true,
    'REPORTAGE' : true,
    'SPORT' : true,
    'VARIÉTÉ' : true,
    'TOUTES CATÉGORIES' : true, 
    'TALK-SHOW' : true,
    'HUMOUR' : true,
    'FICTION-MASCULIN' : true,
    'FICTION-FEMININ' : true,
    'FICTION' : true
  });

  const updateThemeFilter = (event) => {
    const clickedValue = event.target.value;
    // console.log('unselect this', clickedValue);
    setThemesSelected({
      ...themesSelected, 
      [clickedValue]: !themesSelected[clickedValue]
    });
    
    // console.log('unselect this', rangesSelected[clickedValue]);
    props.themeFilterChange(clickedValue);
  }

  // const [chartData, setChartData] = useState([]);
  const chartData = {
    labels: label,
    datasets: [{
        radius: window.screen.availWidth <= 700? 5: 3,
        data: radarChartData,
        fill: true,
        backgroundColor: "#A782FB",
        borderColor: "#A782FB",
        pointBackgroundColor: 'pink',
    }]
  }

  const radarChartOptions = {
    responsive: true,
    rotation: (0.4 * Math.PI),
    legend: {
      display: false
    },
    borderWidth: 100,
    borderCapStyle: 'round', 
    scale: {
      ticks: {
        fontSize: window.screen.availWidth <= 700? 25: 15,
        fontStyle: 'bold'
      },
      pointLabels: {
        fontSize: window.screen.availWidth <= 700 ? 0: 0
      }
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      titleFontSize: window.screen.availWidth <= 700 ? 30: 15,
      bodyFontSize: window.screen.availWidth <= 700 ? 30: 15,
      callbacks: {
        title: function(tooltipItem) { 
          // console.log('tooltipItems', tooltipItem[0]);
          // console.log('value', tooltipItem[0].index);
          return label[tooltipItem[0].index];
        },
        label: function(tooltipItem) { 
          // console.log('tooltipItems', tooltipItem);
          // console.log('data', data);
          return tooltipItem.value + '%';
        },
      }
    }
  };
  
  return (
    <div id="radarChart"> 
      <div class="chartContainer">
        {chartData && <div class="filterTop">
          <div><button id="buttonAround" value='AFFAIRES PUBLIQUES' className={themesSelected['AFFAIRES PUBLIQUES'] ? 'color' : ''} onClick={updateThemeFilter}>AFFAIRES PUBLIQUES</button></div>
          <div><button id="buttonAround" value='ANIMATION' className={themesSelected['ANIMATION'] ? 'color' : ''} onClick={updateThemeFilter}>ANIMATION</button></div>
          <div><button id="buttonAround" value='DOCUMENTAIRE' className={themesSelected['DOCUMENTAIRE'] ? 'color' : ''} onClick={updateThemeFilter}>DOCUMENTAIRE</button></div>
        </div>}
        <div class="radarChart">
          {!chartData && <div class="loader"><Loader /></div>}
          {chartData && <div class="flex">
              {<div class="filterLeft">
                <div>
                <button id="buttonAround"  value='FICTION' className={themesSelected['FICTION'] ? 'color button1' : 'button1'} onClick={updateThemeFilter}>FICTION</button>
                </div>
                <div>
                <button id="buttonAround"  value='FICTION-FEMININ' className={themesSelected['FICTION-FEMININ'] ? 'color button2' : 'button2'} onClick={updateThemeFilter}>FICTION-FEMININ</button>
                </div>
                <div>
                <button id="buttonAround"  value='FICTION-MASCULIN' className={themesSelected['FICTION-MASCULIN'] ? 'color button3' : 'button3'} onClick={updateThemeFilter}>FICTION-MASCULIN</button>
                </div>
                <div>
                <button id="buttonAround"  value='HUMOUR' className={themesSelected['HUMOUR'] ? 'color button4' : 'button4'} onClick={updateThemeFilter}>HUMOUR</button>
                </div>
              </div>}
              <div class="radar">
                <Radar
                  data={chartData} 
                  options={radarChartOptions}
                />
              </div>
              <div class="filterRight">
                <div>
                <button id="buttonAround" value='JEUNESSE' className={themesSelected['JEUNESSE'] ? 'color button1' : 'button1'} onClick={updateThemeFilter}>JEUNESSE</button>
                </div>
                <div>
                <button id="buttonAround" value='MAGAZINE' className={themesSelected['MAGAZINE'] ? 'color button2' : 'button2'} onClick={updateThemeFilter}>MAGAZINE</button>
                </div>
                <div>
                <button id="buttonAround" value='REPORTAGE' className={themesSelected['REPORTAGE'] ? 'color button3' : 'button3'} onClick={updateThemeFilter}>REPORTAGE</button>
                </div>
                <div>
                <button id="buttonAround" value='SPORT' className={themesSelected['SPORT'] ? 'color button4' : 'button4'} onClick={updateThemeFilter}>SPORT</button>
                </div>
              </div>
            </div>}
        </div>
        {chartData && <div class="filterBottom">
          <div><button id="buttonAround" value='TALK-SHOW' className={themesSelected['TALK-SHOW'] ? 'color button1' : 'button1'} onClick={updateThemeFilter}>TALK-SHOW</button></div>
          <div><button id="buttonAround" value='TOUTES CATÉGORIES' className={themesSelected['TOUTES CATÉGORIES'] ? 'color button2' : 'button2'} onClick={updateThemeFilter}>TOUTES CATÉGORIES</button></div>
          <div><button id="buttonAround" value='VARIÉTÉ' className={themesSelected['VARIÉTÉ'] ? 'color button3' : 'button3'} onClick={updateThemeFilter}>VARIÉTÉ</button></div>
        </div>}
      </div>
    </div>
  )
}

export default RadarChart;
